'use client';

import React from 'react';
import { Button } from '@mui/material';
import { useTranslations } from 'next-intl';
import { LinkButton } from 'components/commercetools-ui/atoms/link-button';
import { ROUTES } from 'helpers/constants/routes';
import { IMAGES } from 'frontastic/helper/images-helper';

type ErrorPageProps = {
  reset: () => void;
};

export default function ErrorPage({ reset }: ErrorPageProps) {
  const translate = useTranslations();
  return (
    <div className="m-16 flex h-screen flex-col-reverse items-center justify-center md:m-0 md:flex-row">
      {/* Left Section */}
      <div className="flex w-full flex-1 flex-col items-start justify-start md:w-auto md:items-center md:justify-center md:p-16">
        <div className="w-full text-left md:w-358">
          <h1 className="global-text-xs-bold-degular mb-10 text-xl text-primary">
            {translate('error.something-went-wrong')}
          </h1>
          <p className="global-text-md mb-24 text-secondary">{translate('error.try-again-later-message')}</p>

          <div className="flex w-full flex-col gap-12 md:flex-row md:flex-wrap">
            <Button variant="contained" className="h-40 w-full" onClick={reset}>
              {translate('button.try-again')}
            </Button>
            <LinkButton variant="outlined" className="w-full" link={ROUTES.HOME_ROUTE}>
              {translate('button.go-to-home')}
            </LinkButton>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="flex size-full flex-1 items-center justify-center md:bg-[#FEF7F7] md:p-32">
        <div className="block md:hidden">
          <img src={IMAGES.MOBILE_ERROR} alt="Error" /> {/* eslint-disable-line */}
        </div>
        <div className="hidden md:block">
          <img src={IMAGES.DESKTOP_ERROR} alt="Error" /> {/* eslint-disable-line */}
        </div>
      </div>
    </div>
  );
}
